'use strict';
const angular = require('angular');

export class assetBrowserComponent {
  /*@ngInject*/
  constructor(StorageService, DTOptionsBuilder, DTColumnDefBuilder) {
    this.StorageService = StorageService;

    this.selectedAssets = [];
    this.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef([2]).withOption('type', 'date')
    ];

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withDisplayLength(5)
      .withOption('order', [2, 'desc'])
      .withOption('fnRowCallback', function(nRow, aData, iDisplayIndex) {
        var img = jQuery('img.dt-lazy', nRow);
        img.attr('src', img.attr('lazy-src'));
        return nRow;
      });
  }

  $onInit = function () {
    this.config = this.resolve.config;

    var that = this;

    function onSuccess(data) {
      if (that.config.restrictToFileTypes) {
        that.assets = data.filter(asset => {
          return that.config.restrictToFileTypes.indexOf(asset.contentType) !== -1;
        })
      } else {
        that.assets = data;
      }
    }

    function onError(err) {
      console.log('Could not retrieve data.');
    }

    if (this.config.restrictToUserAssets && this.config.userId) {
      this.StorageService.queryByOwner({
        userid: this.config.userId
      }, onSuccess, onError);
    } else {
      this.StorageService.query(onSuccess, onError);
    }
  };

  getIndexAsset(asset) {
    return this.selectedAssets.map(function(x) {return x._id; }).indexOf(asset._id);
  }

  addAsset(asset) {
    this.selectedAssets.push(asset);
  }

  removeAsset(asset) {
    var idx = this.getIndexAsset(asset);
    this.selectedAssets.splice(idx,1);
  }

  isAssetSelected(asset) {
    return -1 !== this.getIndexAsset(asset);
  }

  ok() {
    this.close({$value: this.selectedAssets});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  getFullname(user) {
    return (user) ? user.firstName + " " + user.lastName : "unknown";
  }
}

export default angular.module('conduu.sm.asset.browser', [])
  .component('assetBrowser', {
    template: require('./asset-browser.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: assetBrowserComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~sm/components/asset/browser/asset-browser.component.js